import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Table, Button } from "react-bootstrap";
import { colorIndex, colors } from "../configs";
import { useSelector } from "react-redux";
import { endCutoff, formatCurrency, getPeriod, goToTop, searchFilterFunction, startCutoff, summary } from "../Utility/function";
import { stringFullDate, stringYMDHMS } from "../Utility/dateTime";
import TablePagination from '@mui/material/TablePagination';
import html2canvas from 'html2canvas';
import { useTranslation } from 'react-i18next';
import * as XLSX from 'xlsx';
import { Checkbox } from 'rsuite';
import { Download, LineChartScreen, PeriodControl, SearchControl, TimeControl } from "../components";

const { white, ten } = colors;

function TrendDiscountScreen() {
  const { t } = useTranslation();
  const { shop } = useSelector((state)=> state.shop)
  const { cutOff } = shop;
  const { selectedBill, startDate, endDate  } = useSelector((state)=> state.bill)
  const [currentDisplay, setCurrentDisplay] = useState([]) // จำนวนที่แสดงในหนึ่งหน้า
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [masterData, setMasterData] = useState([]);
  const [period, setPeriod] = useState('day') // day, week, month
  const [search, setSearch] = useState('');
  const [allSelected, setAllSelected] = useState(true);
  const handleChangePage = (event, newPage) => {
      setPage(newPage); // start form 0
      goToTop()
  };

    const [chartOptions,setChartOptions] = useState([])

    const [selectedChart, setSelectedChart] = useState([])

  const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
      goToTop()
  };


  useEffect(()=>{
    let arr = chartOptions
    if(search){
        arr = searchFilterFunction(chartOptions,search,'name')
    }
    let fData = arr.filter((item,index)=>{return(index >=(page*rowsPerPage) && index <= ((page+1)*rowsPerPage)-1)})
      setCurrentDisplay(fData)
  },[page,rowsPerPage,chartOptions,search])



  const displayRef = useRef(null);

  const handleCapture = () => {
    if (displayRef.current) {
      html2canvas(displayRef.current)
        .then((canvas) => {
          const imgData = canvas.toDataURL('image/png');
          const link = document.createElement('a');
          link.href = imgData;
          link.download = `${t('trendDiscount.trend')}[${period}] ${stringFullDate(startDate,t)} - ${stringFullDate(endDate,t)}.png`;
          link.click();
        });
    }
  };

  const exportToExcel = () => {
    // Create a worksheet from your table data
    const worksheetData = [];

    // Create headers
    const headers = ['No.', t('trendSale.list'), ...masterData.map((a) => a.name)];
    worksheetData.push(headers);

    // Create rows
    currentDisplay.forEach((item, index) => {
      const row = [index + 1, item.name];
      masterData.forEach((a) => {
        row.push(a[item.name]);
      });
      worksheetData.push(row);
    });

    // Sanitize sheet name (remove invalid characters)
    const sanitizeSheetName = (name) => {
      return name.replace(/[\\/:?*[\]]/g, '');
    };

    // Create a new workbook and add the worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();

    // Use sanitized sheet name
    const sheetName = sanitizeSheetName(`${t('trendDiscount.trend')} `);  // You can replace 'Sheet1' with your custom name if needed
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    // Export the workbook to a file
    XLSX.writeFile(workbook, `${t('trendDiscount.trend')}[${period}] ${stringFullDate(startDate,t)} - ${stringFullDate(endDate,t)}.xlsx`);
  };



    // Handler for when the radio button value changes
    const handleChange = (value) => {
        setPeriod(value);
    };

    function sumDiscount(bills){
        let allCampaign = []

        for(const { campaign } of bills){
          for(const { id, name, discount } of campaign){
            let findCampaign = allCampaign.find(b=>b.id===id)
            if(findCampaign){
              findCampaign.discount += Number(discount)
            } else {
              allCampaign.push({ id, name, discount:Number(discount)})
            }
          }
          }
        return allCampaign
      }

    useEffect(()=>{
        let datasets = [] // ยอดขายรายวัน
    
        let periodData = getPeriod({ period, startDate, endDate })

        let allCampaign = []
        
        const uniqueCampaigns = new Set();
        selectedBill.forEach(({ campaign }) => {
            campaign.forEach(({ id, name }) => {
                if (!uniqueCampaigns.has(id)) {
                    uniqueCampaigns.add(id);
                    allCampaign.push({ id, name });
                }
            });
        });

        allCampaign = [{ id:'sale', name:t('trendDiscount.sale')},{ id:'manual', name:t('trendDiscount.manual')},{ id:'pointDiscount', name:'ส่วนลดแลกแต้ม'},{ id:'productDiscount', name:'ส่วนลดสินค้า'},...allCampaign].map((a,i)=>({...a,color:colorIndex[i]||ten}))
  
        for (const { startDate, endDate } of periodData) {
            const start = stringYMDHMS(startCutoff(new Date(startDate), new Date(cutOff)));
            const end = stringYMDHMS(endCutoff(new Date(endDate), new Date(cutOff)));
          
            const data = selectedBill.filter(item => {
              const time = stringYMDHMS(item.dateTime);
              return time > start && time <= end;
            });
          
            const name = period === 'day'
              ? stringFullDate(startDate, t)
              : `${stringFullDate(startDate, t)} - ${stringFullDate(endDate, t)}`;
          
            // Map discount by id
            const discountMap = sumDiscount(data).reduce((map, { id, discount }) => {
              map[id] = parseFloat(discount.toFixed(2));
              return map;
            }, {});
          
            const summaryCampaign = allCampaign.reduce((acc, { name, id }) => {
              acc[name] = discountMap[id] || 0;
              return acc;
            }, {});
          
            // const totalNet = summary(data, 'net')
            const { totalNet, manualDiscount, pointDiscount, productDiscount } = data.reduce(
                ( acc, item )=>{
                    acc.totalNet += item.moneyMustPaid;
                    acc.manualDiscount += Number(item.manualDiscount);
                    acc.pointDiscount += Number(item.pointDiscount.value);
                    acc.productDiscount += Number(item.productDiscount);
                    return acc
                },
                { totalNet:0, manualDiscount:0, pointDiscount:0, productDiscount:0 }
            ) 
          
            datasets.push({
              name,
              ...summaryCampaign,
              [t('trendDiscount.sale')]: parseFloat(totalNet.toFixed(2)),
              [t('trendDiscount.manual')]: manualDiscount,
              ส่วนลดแลกแต้ม:pointDiscount,
              ส่วนลดสินค้า:productDiscount
            });
          }
        setChartOptions(allCampaign)
        setSelectedChart(allCampaign)
        setMasterData(datasets)
    },[selectedBill,period])

    function handleSelectedChart(value){
      let nextSelecetd 
      if(selectedChart.some(a=>a.id===value.id)){
          nextSelecetd = selectedChart.filter(a=>a.id!==value.id)
          
      } else {
          let newSelected = new Set([...selectedChart,value].map(a=>a.id))
          nextSelecetd = chartOptions.filter(a=>newSelected.has(a.id))
      }
      setSelectedChart(nextSelecetd)
      if(nextSelecetd.length===chartOptions.length){
          setAllSelected(true)
      } else {
          setAllSelected(false)
      }
  };

  function handleAllSelected(){
      setAllSelected(prev=>!prev)
      if(allSelected){
          setSelectedChart([])
      } else {
          setSelectedChart(chartOptions)
      }
  }
  return (
    <div style={{ backgroundColor:white }} >
        <h1>แนวโน้มยอดขายตามส่วนลด/โปรโมชั่น</h1>
        <TimeControl/>
        <Row ref={displayRef}  style={styles.container} >
            <Col  lg={12} >
                <div style={styles.container2} >
                    <div style={styles.container3} >
                        <h4>ยอดขายสุทธิ: <b>{formatCurrency(summary(selectedBill,'moneyMustPaid'))}</b> {t('currency')} </h4>
                        <Button onClick={handleCapture} variant="danger" >
                        {t('reportDay.saveGraph')}
                        </Button>
                    </div>
                    <LineChartScreen chart={masterData} lines={selectedChart} />
                </div>
            </Col>
        </Row>
        <div style={styles.container4} >
            <SearchControl {...{ placeholder:t('trendCategory.trend'), search, setSearch }} />&emsp;
            <PeriodControl {...{ period, handleChange }} />&emsp;
            <Download exportToXlsx={exportToExcel} />
        </div>
            
        <Table striped bordered hover responsive  variant="light" style={styles.container6}  >
            <thead  >
            <tr>
                <th style={styles.text}>No.</th>
                <th style={styles.text2}>{t('trendCategory.list')}</th>
                <th style={styles.text3}>
                    <Checkbox 
                        checked={allSelected}
                        className="custom-checkbox"
                        style={styles.container5}
                        onClick={handleAllSelected}
                    >
                        {t('trendCategory.displayAll')}
                    </Checkbox>
                </th>
                {masterData.map((a,i)=>{
                    return <td key={i} style={styles.text3}>{a.name}</td>
                })}
            </tr>
            </thead>
            <tbody  >
            {currentDisplay.map((item, index) => {
                let status = selectedChart.some(a=>a.id===item.id)
                return <tr  key={index} >
                            <td style={styles.text4}>{index+1}.</td>
                            <td  >{item.name}</td>
                            <td style={styles.text4} >
                                <Checkbox 
                                    checked={status}
                                    className="custom-checkbox"
                                    style={{
                                    '--rs-checkbox-checked-bg': item.color,
                                    '--rs-checkbox-checked-border': item.color,
                                    '--rs-checkbox-checked-tick': '#FFFFFF', // To customize the tick color
                                    minWidth:'150px',
                                    marginLeft:'10px'
                                    }}
                                    onClick={()=>{handleSelectedChart(item)}}
                                >
                                    {t('trendCategory.displayGraph')}
                                </Checkbox>
                            </td>
                            {masterData.map((a,i)=>{
                                return <td key={i} style={styles.text4}>{formatCurrency(a[item.name])}</td>
                            })}
                        </tr>
            })}
            </tbody>
        </Table>
        <TablePagination
            component="div"
            count={chartOptions.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
        />
    </div>
  );
};


const styles = {
    container : {
        backgroundColor:white,borderRadius:20,marginLeft:0,marginRight:0,marginBottom:20
    },
    container2 : {
        backgroundColor:white,margin:5,padding:10,borderRadius:20,height:'400px',marginRight:0
    },
    container3 : {
        display:'flex',justifyContent:'space-between',alignItems:'center'
    },
    container4 : {
        display:'flex',alignItems:'center',justifyContent:'flex-end',padding:10
    },
    container5 : {
      '--rs-checkbox-checked-bg': '#F44336',
                      '--rs-checkbox-checked-border': '#F44336',
                      '--rs-checkbox-checked-tick': '#FFFFFF', // To customize the tick color
                      minWidth:'150px',
                      marginLeft:'10px'
    },
    container6 : {
        marginLeft:'1rem'
    },
    text : {
        width: '10%', textAlign:'center'
    },
    text2 : {
        width: '30%', textAlign:'center', minWidth:'250px' 
    },
    text3 : {
        width: '10%', textAlign:'center', minWidth:'180px'
    },
    text4 : {
        textAlign:'center'
    }
}

export default TrendDiscountScreen;
